import { render, staticRenderFns } from "./BuildingListContactCard.vue?vue&type=template&id=37d9da6b&scoped=true"
import script from "./BuildingListContactCard.vue?vue&type=script&lang=js"
export * from "./BuildingListContactCard.vue?vue&type=script&lang=js"
import style0 from "./BuildingListContactCard.vue?vue&type=style&index=0&id=37d9da6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9da6b",
  null
  
)

export default component.exports